export default __webpack_public_path__ + "static/media/disgusted_elaine_on.18f1155a.png";